import { ImageModel, SplitModel } from "@courses-pm2/api";

import { ImageComponent } from "@courses-pm2/image-component";
import { RichtextComponent } from "@courses-pm2/richtext-component";

import * as styles from "./_split.style";

type Props = {
  model: SplitModel;

  inLightbox?: boolean;
  openLightbox?: (args: { model: ImageModel; node: HTMLDivElement }) => void;
  openInternalLink?: (args: {
    path: string;
    portalId: string;
    newWindow?: boolean;
  }) => void;
};

export function SplitComponent(props: Props) {
  const content = (() => {
    const imageNode = (
      <ImageComponent
        model={props.model.image}
        inLightbox={props.inLightbox}
        openInternalLink={props.openInternalLink}
        openLightbox={props.openLightbox}
      />
    );

    const textNode = <RichtextComponent model={props.model.text} />;

    switch (props.model.options.layout) {
      case "image-text":
        return (
          <>
            {imageNode}
            {textNode}
          </>
        );

      case "text-image":
        return (
          <>
            {textNode}
            {imageNode}
          </>
        );
    }
  })();

  return <div className={styles.wrapper}>{content}</div>;
}
